import { SEOMeta } from '../components/common/SEOMeta';
import { SectionTitle } from '../components/common/SectionTitle';
import { useScrollReveal } from '../hooks/useScrollReveal';
import '../assets/css/pages/About.css';

export default function About() {
  const introReveal = useScrollReveal();
  const mvReveal = useScrollReveal();
  const teamReveal = useScrollReveal();
  const valuesReveal = useScrollReveal();
  const timelineReveal = useScrollReveal();

  const coreValues = [
    { icon: "fa-solid fa-gem", title: "Quality First", subtitle: "We never compromise on engineering standards." },
    { icon: "fa-solid fa-handshake", title: "Transparency", subtitle: "Clear communication at every project phase." },
    { icon: "fa-solid fa-lightbulb", title: "Innovation", subtitle: "Adopting modern tech to solve hard problems." },
    { icon: "fa-solid fa-users", title: "Collaboration", subtitle: "We work as an extension of your team." },
  ];

  const teams = [
    { avatar: "ID", name: "Irshad Dekavadiya", role: "CEO & Founder", desc: "Visionary technologist with 15+ years in software architecture." },
    { avatar: "RS", name: "Ravina Sanghani", role: "Co-Founder", desc: "Expert in cloud infrastructure and scalable system design." },
  ];

  const ourJourney = [
    { year: "2018", title: "Company Founded", subtitle: "Logicraft Infotech established in Rajkot, focusing on web development." },
    { year: "2020", title: "Mobile Expansion", subtitle: "Launched our mobile app development division and expanded our engineering team." },
    { year: "2022", title: "Global Reach", subtitle: "Partnered with international clients across NA and Europe, delivering enterprise solutions." },
    { year: "2024", title: "AI & Cloud Focus", subtitle: "Deepening our expertise in AI integration and advanced cloud architectures." },
  ];

  const technologyStack = [
    { icon: "fa-brands fa-react", title: "React" },
    { icon: "fa-brands fa-node-js", title: "Node.js" },
    { icon: "fa-brands fa-python", title: "Python" },
    { icon: "fa-brands fa-aws", title: "AWS" },
    { icon: "fa-brands fa-docker", title: "Docker" },
    { icon: "fa-brands fa-figma", title: "Figma" },
    { icon: "fa-brands fa-github", title: "Github" },
  ];
  return (
    <>
      <SEOMeta
        title="About Us"
        description="Learn about Logicraft Infotech, our mission, vision, and the expert team behind our solutions."
        canonical="https://www.logicraftinfotech.com/about"
      />

      <section className="about-hero" ref={introReveal.ref}>
        <div className={`container ${introReveal.className}`}>
          <SectionTitle title="About Logicraft Infotech" centered />
          <p className="about-intro">
            Founded with a vision to engineer excellence, Logicraft Infotech is a collective of passionate technologists, designers, and strategists. We build the digital infrastructure that powers modern enterprises.
          </p>
        </div>
      </section>

      <section className="section" ref={mvReveal.ref}>
        <div className={`container ${mvReveal.className}`}>
          <div className="mission-vision">
            <div className="mv-card">
              <i className="fa-solid fa-rocket"></i>
              <h3>Our Mission</h3>
              <p>
                To empower businesses through robust, scalable, and innovative software solutions. We strive to abstract technical complexity, allowing our clients to focus on their core growth while we handle the digital execution.
              </p>
            </div>
            <div className="mv-card">
              <i className="fa-solid fa-eye"></i>
              <h3>Our Vision</h3>
              <p>
                To be the global engineering partner of choice for forward-thinking organizations, recognized for our uncompromising quality, technical precision, and commitment to shaping the future of technology.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--gradient-hero)' }} ref={valuesReveal.ref}>
        <div className={`container ${valuesReveal.className}`}>
          <SectionTitle title="Core Values" centered />
          <div className="values-grid">
            {coreValues.map((step, i) => (
              <div className="value-card" key={i}>
                <i className={step.icon}></i>
                <h4>{step.title}</h4>
                <p>{step.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" ref={teamReveal.ref}>
        <div className={`container ${teamReveal.className}`}>
          <SectionTitle title="Leadership Team" subtitle="The architects behind our success." centered />
          <div className="team-grid">
            {teams.map((team, i) => (
              <div className="team-card" key={i}>
                <div className="team-avatar">{team.avatar}</div>
                {/* <h3 className="team-name">{team.name}</h3> */}
                <div className="team-role">{team.role}</div>
                <p>{team.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: 'var(--card-bg)' }} ref={timelineReveal.ref}>
        <div className={`container ${timelineReveal.className}`}>
          <SectionTitle title="Our Journey" centered />
          <div className="timeline">
            {ourJourney.map((timeline, i) => (
              <div className="timeline-item" key={i}>
                <div className="timeline-year">{timeline.year}</div>
                <h4>{timeline.title}</h4>
                <p>{timeline.subtitle}</p>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 'var(--spacing-xxl)' }}>
            <SectionTitle title="Technology Stack" centered />
            <div className="tech-stack">
              {technologyStack.map((stack, i) => (
                <div className="tech-item" title={stack.title} key={i}><i className={stack.icon}></i></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}